/**
 * Breadcrumbs Component
 * Reusable breadcrumb navigation showing page hierarchy
 */

import { Link } from 'react-router-dom';
import { ChevronRight, Home } from 'lucide-react';
import type { LucideIcon } from 'lucide-react';

export interface BreadcrumbItem {
  label: string;
  to?: string;
  icon?: LucideIcon;
}

interface BreadcrumbsProps {
  items: BreadcrumbItem[];
}

export const getRootBreadcrumb = (): BreadcrumbItem => ({
  label: 'Home',
  to: '/home',
  icon: Home,
});

export const Breadcrumbs = ({ items }: BreadcrumbsProps) => {
  if (items.length === 0) return null;

  return (
    <nav className="flex items-center text-sm">
      {items.map((item, index) => (
          <span key={index} className="flex items-center">
            {index > 0 && (
              <ChevronRight className="h-3 w-3 mx-2 text-meta flex-shrink-0" />
            )}
            {item.to ? (
              <Link
                to={item.to}
                className="text-body hover:underline"
              >
                {item.icon ? <item.icon className="h-4 w-4" aria-label={item.label} /> : item.label}
              </Link>
            ) : (
              <span className="text-meta">
                {item.icon ? <item.icon className="h-4 w-4" aria-label={item.label} /> : item.label}
              </span>
            )}
          </span>
      ))}
    </nav>
  );
};
